import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DeviceStatus } from "@shared/models/device-status";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DeviceStatusService {
  private readonly baseUrl = `${environment.vibrationApiURL}/device-status`;

  constructor(private http: HttpClient) {}

    /**
     * Get device status by serial number
     * @param deviceSerialNumber Device serial number
     * @returns Observable with device status
     */
    getDeviceStatus(deviceSerialNumber: string): Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/${deviceSerialNumber}`);
    }
}